export default "__VITE_ASSET__BBupkewf__"